module.exports = __webpack_public_path__ + "img/three-men-hats-1080p.1526f945.jpg";